import { i18nHashes } from './hashes/i18n-hashes';

export type TranslationKeys = typeof import('./assets/i18n/en.json');
export type LanguageCode = 'en' | 'da' | 'fr' | 'de' | 'es' | 'it' | 'no' | 'pl' | 'nn' | 'nb';
export const locals = ['en', 'da', 'fr', 'de', 'es', 'it', 'no', 'pl'] as const;
export type SupportedLanguageCode = (typeof locals)[number];

export let defaultLanguage: SupportedLanguageCode = 'en';

export function normalizeLanguageCode(code: LanguageCode | string): SupportedLanguageCode {
    return code === 'nn' || code === 'nb' ? 'no' : (code as SupportedLanguageCode);
}

export function getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((current, key) => current?.[key], obj);
}

export function setLanguageCode(langCode: LanguageCode): SupportedLanguageCode {
    const normalizedLang = normalizeLanguageCode(langCode) as SupportedLanguageCode;
    defaultLanguage = normalizedLang;
    return normalizedLang;
}

export type RecursiveKeyOf<TObj extends Record<string, any>> = {
    [TKey in keyof TObj & string]: TObj[TKey] extends Record<string, any> ? `${TKey}` | `${TKey}.${RecursiveKeyOf<TObj[TKey]>}` : `${TKey}`;
}[keyof TObj & string];

export type LocalizedKeys = RecursiveKeyOf<TranslationKeys>;

export { i18nHashes };
